import type { Boveda, CategoriaGasto, TipoMovimientoBoveda } from '@barbones/shared';

export const ETIQUETA_BOVEDA: Record<Boveda, string> = { efectivo: 'Efectivo', banco: 'Banco' };

export const ETIQUETA_CATEGORIA: Record<CategoriaGasto, string> = {
  renta: 'Renta',
  insumos: 'Insumos',
  compra_productos: 'Compra de productos',
  sueldos: 'Sueldos',
  servicios: 'Servicios (luz, agua, internet)',
  herramientas: 'Herramientas',
  ferreteria: 'Ferretería',
  otro: 'Otro',
};

export const ETIQUETA_TIPO: Record<TipoMovimientoBoveda, string> = {
  saldo_inicial: 'Saldo inicial',
  ingreso_cierre: 'Ingreso al cerrar caja',
  ingreso: 'Ingreso',
  retiro: 'Retiro',
  traspaso_salida: 'Traspaso (sale)',
  traspaso_entrada: 'Traspaso (entra)',
  correccion_compra: 'Corrección de compra',
};

/** Texto en pesos → centavos (0 si no es número). */
export const aCentavos = (t: string) => Math.round((Number.parseFloat(t) || 0) * 100);
